export const getRoleName = (r: unknown): string | undefined => {
  if (typeof r === "string") return r;
  if (r && typeof r === "object") {
    const anyR = r as any;
    return anyR?.role?.name ?? anyR?.name;
  }
  return undefined;
};

const COMPANY_SUPER_ADMIN_ROLES = new Set([
  "EXHIBITOR_SUPER_ADMIN",
  "SPONSOR_SUPER_ADMIN",
]);

/** Exhibitor/sponsor company owners — full portal permission bypass in UI. */
export const isCompanySuperAdminRole = (r: unknown): boolean => {
  const name = getRoleName(r);
  return name ? COMPANY_SUPER_ADMIN_ROLES.has(name) : false;
};

